import { getCallable } from "../_sdk/client";
import { apiName, endpoints } from "./endpoints";
import {
    GenerateSlideRequest, GenerateSlideResponse,
    GeneratePresentationOutlineRequest, GeneratePresentationOutlineResponse,
    GenerateWordCloudRequest, GenerateWordCloudResponse,
    RewriteTextRequest, RewriteTextResponse,
    GenerateSlideNotesRequest, GenerateSlideNotesResponse,
    AnalyzeWebpageRequest, AnalyzeWebpageResponse,
    GenerateImagesRequest, GenerateImagesResponse,
    TranslateTextRequest, TranslateTextResponse,
    TranslateSlideRequest, TranslateSlideResponse,
    TranslatePresentationRequest, TranslatePresentationResponse,
    GetCreditsBalanceRequest, GetCreditsBalanceResponse
} from "./types";

export { apiName };

const generateSlide = getCallable<GenerateSlideRequest, GenerateSlideResponse>(apiName, "generateSlide", {
    ...endpoints.generateSlide,
    composer: request => {
        return {
            url: "/slides/generate",
            options: {
                method: "POST",
                body: JSON.stringify(request)
            }
        };
    }
});

const generateSlidePublic = getCallable<GenerateSlideRequest, GenerateSlideResponse>(apiName, "generateSlidePublic", {
    ...endpoints.generateSlidePublic,
    composer: request => {
        return {
            url: "/slides/generate-public",
            options: {
                method: "POST",
                body: JSON.stringify(request)
            }
        };
    }
});

const generatePresentationOutline = getCallable<GeneratePresentationOutlineRequest, GeneratePresentationOutlineResponse>(apiName, "generatePresentationOutline", {
    ...endpoints.generatePresentationOutline,
    composer: request => {
        return {
            url: "/presentations/generate-outline",
            options: {
                method: "POST",
                body: JSON.stringify(request)
            }
        };
    }
});

const generateWordCloud = getCallable<GenerateWordCloudRequest, GenerateWordCloudResponse>(apiName, "generateWordCloud", {
    ...endpoints.generateWordCloud,
    composer: request => {
        return {
            url: "/wordcloud/generate",
            options: {
                method: "POST",
                body: JSON.stringify(request)
            }
        };
    }
});

const rewriteText = getCallable<RewriteTextRequest, RewriteTextResponse>(apiName, "rewriteText", {
    ...endpoints.rewriteText,
    composer: request => {
        return {
            url: "/text/rewrite",
            options: {
                method: "POST",
                body: JSON.stringify(request)
            }
        };
    }
});

const generateSlideNotes = getCallable<GenerateSlideNotesRequest, GenerateSlideNotesResponse>(apiName, "generateSlideNotes", {
    ...endpoints.generateSlideNotes,
    composer: request => {
        return {
            url: "/slides/generate-notes",
            options: {
                method: "POST",
                body: JSON.stringify(request)
            }
        };
    }
});

const analyzeWebpage = getCallable<AnalyzeWebpageRequest, AnalyzeWebpageResponse>(apiName, "analyzeWebpage", {
    ...endpoints.analyzeWebpage,
    composer: request => {
        return {
            url: "/analyze/webpage",
            options: {
                method: "POST",
                body: JSON.stringify(request)
            }
        };
    }
});

const generateImages = getCallable<GenerateImagesRequest, GenerateImagesResponse>(apiName, "generateImages", {
    ...endpoints.generateImages,
    composer: request => {
        return {
            url: "/images/generate",
            options: {
                method: "POST",
                body: JSON.stringify(request)
            }
        };
    }
});

const translateText = getCallable<TranslateTextRequest, TranslateTextResponse>(apiName, "translateText", {
    ...endpoints.translateText,
    composer: request => {
        return {
            url: "/text/translate",
            options: {
                method: "POST",
                body: JSON.stringify(request)
            }
        };
    }
});

const translateSlide = getCallable<TranslateSlideRequest, TranslateSlideResponse>(apiName, "translateSlide", {
    ...endpoints.translateSlide,
    composer: request => {
        return {
            url: "/slides/translate",
            options: {
                method: "POST",
                body: JSON.stringify(request)
            }
        };
    }
});

const translatePresentation = getCallable<TranslatePresentationRequest, TranslatePresentationResponse>(apiName, "translatePresentation", {
    ...endpoints.translatePresentation,
    composer: request => {
        return {
            url: "/presentations/translate",
            options: {
                method: "POST",
                body: JSON.stringify(request)
            }
        };
    }
});

const getCreditsBalance = getCallable<GetCreditsBalanceRequest, GetCreditsBalanceResponse>(apiName, "getCreditsBalance", {
    ...endpoints.getCreditsBalance,
    composer: request => {
        return {
            url: `/credits/balance?workspaceId=${encodeURIComponent(request.workspaceId)}`,
            options: {
                method: "GET"
            }
        };
    }
});

export const callables = {
    generateSlide,
    generateSlidePublic,
    generatePresentationOutline,
    generateWordCloud,
    rewriteText,
    generateSlideNotes,
    analyzeWebpage,
    generateImages,
    translateText,
    translateSlide,
    translatePresentation,
    getCreditsBalance
};
